import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=085f2064&scoped=true&"
import script from "./BatchOrder.vue?vue&type=script&lang=js&"
export * from "./BatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./BatchOrder.vue?vue&type=style&index=0&id=085f2064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f2064",
  null
  
)

export default component.exports